import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";

// get Tool Category list
export const getToolCategoriesService = async () => {
  try {
    const response = await apiClient.get(`/api/tool-category-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get Tool types list
export const getToolTypesService = async () => {
  try {
    const response = await apiClient.get(`/api/tool-type-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get Tool brands list
export const getToolBrandsService = async () => {
  try {
    const response = await apiClient.get(`/api/tool-brand-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get Tool storage list
export const getToolStorageService = async () => {
  try {
    const response = await apiClient.get(`/api/tool-storage-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get Tools list
export const getToolsService = async () => {
  try {
    const response = await apiClient.get(`/api/tool-data-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//add tool brand
export const addToolBrand = async (
  brand_name: string
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();
    formData.append("brand_name", brand_name);

    const response = await fetch(`${baseURL}/api/tool-brand-create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//add storage
export const addToolStorage = async (
  storage_name: string
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();
    formData.append("storage_name", storage_name);

    const response = await fetch(`${baseURL}/api/tool-storage-create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create tools
export const addTools = async (
  keep_in: string,
  project_id: number,
  storage_id: number,
  category_id: number,
  type_id: number,
  brand_id: number,
  tool_name: string | null,
  note: string,
  tool_count: number,
  have_warranty: number,
  buying_date: string,
  warranty_period: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/tool-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        keep_in,
        project_id,
        storage_id,
        category_id,
        type_id,
        brand_id,
        tool_name,
        note,
        tool_count,
        have_warranty,
        buying_date,
        warranty_period,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update tools
export const updateTools = async (
  keep_in: string,
  project_id: number,
  storage_id: number,
  category_id: number,
  type_id: number,
  brand_id: number,
  tool_name: string,
  note: string,
  tool_count: number,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/tool-update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        keep_in,
        project_id,
        storage_id,
        category_id,
        type_id,
        brand_id,
        tool_name,
        note,
        tool_count,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update tools
export const swapTools = async (
  keep_in: string,
  project_id: number | null,
  storage_id: number | null,
  tool_count: number,
  is_damage: number,
  damage_note: string,
  id: number
): Promise<CommonApiResponse> => {
  try {


    const input = {
      "keep_in": keep_in,
      "project_id": project_id,
      "storage_id": storage_id,
      "is_damage": is_damage,
      "damage_note": damage_note,
      "tool_count": tool_count,
    };
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/tool-address-changed/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify(input),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete tool
export const deleteToolData = async (id: number): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem('token');
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/tool-delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': FULL_TOKEN
      },
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }

  } catch (error) {
    throw error;
  }
};